import React from 'react';
import s from './s.module.less';
import { CheckOutlined } from '@ant-design/icons';

const Step1 = () => {
    const steps = [
        {
            id: 1,
            title: 'Create profile',
            status: 'completed',
        },
        {
            id: 2,
            title: 'Set up services',
            status: 'completed',
        },
        {
            id: 3,
            title: 'List on Klarity Health',
            status: 'completed',
        },
        {
            id: 4,
            title: 'Configure availability',
            status: 'current',
        },
    ];

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                <div className={s.header}>
                    <h1>Final step: Set availability to open your schedule for patients</h1>
                    <div className={s.headerDescription}>
                        Add your available days and times to help patients book with you as soon as your profile is approved, and keep your schedule running smoothly.
                    </div>
                </div>

                <div className={s.progressContainer}>
                    {steps.map((step, index) => (
                        <div key={step.id} className={s.stepWrapper}>
                            <div className={s.stepItem}>
                                <div className={`${s.stepIcon} ${s[step.status]}`}>
                                    {step.status === 'completed' ? (
                                        <CheckOutlined className={s.checkIcon} />
                                    ) : (
                                        <span className={s.stepNumber}>{step.id}</span>
                                    )}
                                </div>
                                <span className={`${s.stepTitle} ${s[step.status]}`}>
                                    {step.title}
                                </span>
                            </div>

                            {index < steps.length - 1 && (
                                <div className={`${s.connector} ${steps[index + 1].status === 'completed' ? s.completed : s.pending}`} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Step1;
